'use client'

import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const CalloutBox = styled(Box)(({ theme }) => ({
  borderRadius: '20px',
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(4.5),
  marginTop: '-3px',
  color: theme.palette.text.secondary,
}))

export default {}
